import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import dotracking from '../../../trackinglogs';
import trackobj from "../../../trackingpages.json"
import { schformdetail } from '../../../../services/superadmin';
import moment from 'moment';

export const ViewSchloarship = () => {
    const { id } = useParams();
    const [fdetail, setFDetail] = useState("");
    const navigate = useNavigate();
    function backlist() {
        dotracking("back button in scholarship detail for " + fdetail?.form_name + " (" + id + ") $$ " + trackobj.schlistheading);
        if (localStorage.getItem("Role") === '8') {
            navigate("/funder/scholarshipformlist")
        } else if (localStorage.getItem("Role") === '3') {
            navigate("/cityregional/scholarshipformlist")
        }
    }
    useEffect(() => {

        schformdetail(id).then((res) => {
            if (res.status === true) {
                setFDetail(res.data.scholarship_form);
            }
        });
    }, []);
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Scholarship Detail</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Scholarship Detail
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="card mt-0">
                    <div className="card-body">

                        <div className="row tournamentitem">
                            <div className="col-md-6">
                                <div className="details-group">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <b className="text-inverse">Form Name</b>
                                        </div>
                                        <div className="col-md-8">
                                            <span className="text-inverse">{fdetail?.form_name}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="details-group">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <b className="text-inverse">Entry Start Date</b>
                                        </div>
                                        <div className="col-md-8">
                                            <span className="text-inverse">{fdetail ? moment(fdetail.form_entry_start_date).format("DD-MM-YYYY") : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="details-group">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <b className="text-inverse">Entry End Date</b>
                                        </div>
                                        <div className="col-md-8">
                                            <span className="text-inverse">{fdetail ? moment(fdetail.form_entry_end_date).format("DD-MM-YYYY") : ''}</span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="details-group">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <b className="text-inverse">Funder Name</b>
                                        </div>
                                        <div className="col-md-8">
                                            <span className="text-inverse">{fdetail?.funder_name}</span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="col-md-12">
                                <div className="details-group">
                                    <div className="row">
                                        <div className="col-lg-2">
                                            <b className="text-inverse">Form Description</b>
                                        </div>
                                        <div className="col-md-10">
                                            <div
                                                dangerouslySetInnerHTML={{ __html: fdetail?.form_info_content }}
                                            />
                                            {/* <span className="text-inverse">{fdetail?.form_info_content}</span> */}
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="card-footer text-center border-top">
                        <button
                            type="submit"
                            className="btn btn-gray me-2"
                            onClick={backlist}
                        >
                            Back
                        </button>

                    </div>
                </div>
            </div>

        </div>
    )
}
